import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "getKey" */ './index'),
  loading: () => null,
});
